import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  enabled: () => faker.datatype.boolean(0.75),
  kioskCount: () => faker.number.int({ min: 0, max: 10 }),
  locationName: () => faker.location.city(),
  ringDuration: 30,

  afterCreate(configuration, server) {
    if (configuration.location) {
      configuration.update({ locationName: configuration.location.name });
    } else {
      configuration.update({
        location: server.create('location', { name: configuration.locationName }),
      });
    }
  },
});
